/* eslint-disable  */

export default {
  "Category Empty": "Tässä kategoriassa ei ole tuotteita",
  "Choose currency": "Valitse valuutta",
  "Menu": "Valikko",
  "Account": "Tili",
  "Add to cart": "Lisää ostoskoriin",
  "Search": "Haku",
  "Choose language": "Valitse kieli",
  "error": "virhe",
  "Cart":"Ostoskori",
  "Home": "Koti",
  "Filters": "Suodattimet",
  "quantity-input": "Määrän syöttäminen",
  "ERROR_PAGE_404_TITLE": "Apua, yksi sivu puuttuu!",
  "ERROR_PAGE_404_DESCRIPTION": "Miten me nyt saamme tietää, miten tarina päättyy?! Joskus suuretkin asiat saattavat kadota tai joutua epätavallisiin paikkoihin… Onkohan Esi-isällä tekemistä asian kanssa?",
  "ERROR_PAGE_500_TITLE": "Huhuu, onko täällä ketään?",
  "ERROR_PAGE_500_DESCRIPTION": "Ei taida olla, vaikka ovet ovatkin Muumitalon tapaan auki. Perhe on kuulemma kalassa, joten päätimme sillä aikaa tehdä verkkosivuillemme muutamia parannuksia. Jos haluat, voit kaataa itsellesi muumimukillisen ja istuutua verannalle odottamaan.",
  "ERROR_PAGE_HOME_BUTTON": "Etusivulle",
  "ERROR_PAGE_BACK_BUTTON": "Takaisin",
  "PRODUCT_ARTICLE_NUMBER": "Tuotenumero",
  "PRODUCT_WIDTH": "leveys  (cm)",
  "PRODUCT_HEIGHT": "korkeus  (cm)",
  "PRODUCT_LENGTH": "pituus  (cm)",
  "PRODUCT_WEIGHT": "paino  (kg)",
  "PAGES": {
    "CHECKOUT": "/kassalle",
    "CART": "/ostoskori",
    "FORGOT_PASSWORD": "/unohditko-salasanasi",
    "LOGIN": "/kirjaudu",
    "REGISTRATION": "/rekisterointi",
    "REGISTRATION_SUCCESS": "/rekisteroinnin-onnistuminen",
    "ORDER_CONFIRMATION": "/tilausvahvistus",
    "ONGOING_OR_REFUSED_PAYMENT": "/maksuprosessi",
    "MY_ACCOUNT": "/tilini",
    "ADDRESS_BOOK": "/tilini/osoitekirja",
    "PERSONAL_DETAILS": "/tilini/henkilotiedot",
    "PURCHASE_HISTORY": "/tilini/ostohistoria",
    "SEARCH_RESULTS": "/hakutulossivu",
    "MOOMIN_DAY_2024": "/kokoelmat-ja-inspiraatio/mooments/muumin-paiva-2024"
  },
  "SORTING": {
    "RELEVANCY": "Osuvimmat",
    "NEWEST": "Uusimmat",
    "OLDEST": "Vanhimmat",
    "ALPHABETICAL": "Aakkosjärjestys",
    "PRICE_ASCENDING": "Hinta: halvin ensin",
    "PRICE_DESCENDING": "Hinta: kallein ensin",
  },
  "FACETS": {
    "PRODUCT_TYPE": "Tuotekategoria",
    "COLOR": "Väri",
    "COLLECTION": "Kokoelma",
    "PRICE": "Hinta",
    "SIZE": "Koko",
  },
  "LOCALE_CHANGE": {
    "REMAINING_BUTTON": "Pysy sivulla Moomin Arabia {0}",
    "GET_TO_DEFAULT_LOCALE_BUTTON": "Siirry sivulle Moomin Arabia {0}",
    "GET_TO_DEFAULT_LOCALE_TITLE": "Haluatko sittenkin vierailla sivulla Moomin Arabia {0}?",
    "SELECT_DIFFERENT_LOCALE": "Valitse eri maa",
    "CONFIRMATION_TITLE": "Vahvistus",
    "DETAILS": "Näyttää siltä, että selaat kauppaa, joka ei ehkä toimita maahasi sijaintisi ja aiempien vierailujesi perusteella."
  },
  "LOCALE_SELECTOR": {
    "TITLE": "Valitse toimituspaikkasi",
    "SELECTED_COUNTRY_LABEL": "Toimitus kohteeseen:",
    "CHANGE_BUTTON": "Vaihda",
    "LABEL": "Teet ostoksia sijainnissa",
    "CLOSE_MODAL": "Sulje maa-valitsin",
    "COUNTRY_LABEL": "Valitse {0}"
  },
  "CARD_PLACEHOLDERS": {
    "NUMBER": "1234 5678 9012 3456",
    "NAME": "J. Smith",
    "EXPIRY": "KK / VV",
    "CVC": "3 lukua"
  },
  "Payment refused due to": "Maksu hylätty, koska",
  "with reference id for card:": "kortin viitetunnuksella:",
  "Payment successful with reference id:": "Maksu onnistui viitetunnuksella:",
  "notify-me-disclaimer": "Käytämme sähköpostiosoitettasi vain ilmoittaaksemme sinulle, kun tuote tulee saataville. Tilaamalla ilmoituksen hyväksyt ",
  "privacy-policy-url": "https://fiskarsgroup.com/fi/fiskars-groupin-tietosuojakaytannot/tietosuojakaytanto-kuluttajille/",
  "privacy-policy": "tietosuojakäytäntömme",
  "copy-billing-address": "Kopioi laskutusosoite",
  "buttons": {
    "navigation": {
      "my-account": "Siirry tilillesi",
      "cart": "Siirry ostoskoriin",
      "home": "Siirry etusivulle",
      "search": "Etsi tuotteita",
      "menu": "Avaa valikko",
      "login": "Kirjaudu"
      },
      "locale-selector": {
        "trigger": "Avaa maavalitsin",
      },
      "password-show": "Näytä salasana",
      "password-hide": "Piilota salasana",
      "back": "Palaa",
      "close": "Sulje",
      "register": "Rekisteröidy",
      "close-notification": "Sulje ilmoitus",
      "go-to-product": "Siirry tuotteeseen {product}",
      "go-to-category": "Siirry kategoriaan {category}",
      "add-product-to-cart": "Lisää {product} ostoskoriin",
      "get-notified": "Saat ilmoituksen aiheesta {product}",
      "video": {
        "play": "Toista video",
        "pause": "Keskeytä video",
        "mute": "Mykistä video",
        "unmute": "Poista videon mykistys",
      },
      "filters": {
        "open-filters": "Avaa suodatinvaihtoehdot",
        "clear-filter": "Tyhjennä {0} suodatin",
        "clear-all-filters": "Tyhjennä kaikki",
        "filter-by": "Suodattaa {0}",
        "removed-all-filters": "Kaikki suodattimet on poistettu",
        "removed-filter": "{0} suodatin on poistettu",
      },
      "sorting-changed-to": "Lajittelu muutettu muotoon",
      "sort-by": "Lajittela",
      "edit-address": "Muokkaa {0} osoitetta",
      "edit-shipping-info": "Muokkaa toimitustietoja",
      "edit-billing-info": "Muokkaa laskutustietoja",
      "edit-shopping-cart": "Muokkaa ostoskoria",
      "edit-personal-info": "Muokkaa henkilötietoja",
      "gallery-images": "Kuva {0} / {1}",
      "reduce-quantity": "Vähentää määrää",
      "increase-quantity": "Lisää määrää",
      "open-dropdown": "Avaa pudotusvalikko",
      "dropdown-openers": {
        "sorting-options": "Avaa lajitteluvaihtoehdot",
        "phone-country-code-options": "Avaa puhelimen maakoodivaihtoehdot",
        "contact-reason-options": "Avaa yhteydenottosyyn vaihtoehdot",
        "country-options": "Avaa maavaihtoehdot",
      },
      "selected-option": "Valittu vaihtoehto",
      "carousel": {
        "previous-slide": "Siirry edelliseen diaan",
        "next-slide": "Siirry seuraavaan diaan",
        "go-to-slide": "Siirry diaan {0}",
        "current-slide": "Nykyinen dia",
      },
      "radio": {
        "choose-shipping-method": "Valitse toimitustapa",
        "choose-billing-address": "Valitse laskutusosoite",
        "choose-pickup-point": "Valitse noutopaikka"
      }
  }
}
